import { EXTERNAL_URL, STATIC_SITE_MAP } from '../../consts/asial-websites-sitemap.const';
import FldRef from '../../resources/Footer-list-decorator.svg';
import OuterlinkIconRef from '../../resources/Outerlink.svg';
import DownloadIconRef from '../../resources/Download-icon.svg';
import originalStyles from '../../styles/asial-website-footer.module.scss';
import cn from 'classnames';
import React, { ReactNode, createContext, memo, useContext, useState } from 'react';
import { extractStyle } from '../../styles/styles-extract-util';
import GlobalIconRef from '../../resources/Language-icon.svg';
import AccordionOpenIconRef from '../../resources/Accordion-open.svg';
import AccordionCloseIconRef from '../../resources/Accordion-close.svg';

const fld = `${FldRef}#fld`;
const oli = `${OuterlinkIconRef}#outerlink`;
const dli = `${DownloadIconRef}#download-icon`;
const aop = `${AccordionOpenIconRef}#accordion-open`;
const acl = `${AccordionCloseIconRef}#accordion-close`;

const StylesContext = createContext(extractStyle(originalStyles));
const AccordionContext = createContext<{ state: string } | null>(null);
const Context = ({ styles, accordion, children }: { styles?: any; accordion?: { state: string }; children: ReactNode }) => {
  return (
    <StylesContext.Provider value={styles}>
      <AccordionContext.Provider value={accordion || null}>{children}</AccordionContext.Provider>
    </StylesContext.Provider>
  );
};

export const AsialWebsiteFooterSitemap: React.FC = () => {
  const styles = extractStyle(originalStyles);
  const getURLFromSitemapData = ({ host, path }: { host: string; path: string }) => host + path;
  const accordionStatus = {
    [STATIC_SITE_MAP.SOLUTIONS.title]: useState('default'),
    [STATIC_SITE_MAP.PRODUCTS.title]: useState('default'),
    [STATIC_SITE_MAP.COMPANY.title]: useState('default'),
    [STATIC_SITE_MAP.CAREERS.title]: useState('default')
  };
  const getAccordionStatus = (title: string) => accordionStatus[title][0];
  const setAccordionStatus = (title: string, status: string) => accordionStatus[title][1](status);

  return (
    <div className={cn(styles['sitemap-wrapper'], styles['base-grid'])}>
      <div className={styles['sitemap']}>
        <div className={styles['sitemap-contents']}>
          <Context styles={styles}>
            <LargeCategory categoryKey="home" title={STATIC_SITE_MAP.HOME.title} url={getURLFromSitemapData(STATIC_SITE_MAP.HOME)} />
          </Context>
          <Context styles={styles}>
            <LargeCategory categoryKey="strengths" title={STATIC_SITE_MAP.STRENGTHS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.STRENGTHS)} />
          </Context>
          <Context styles={styles} accordion={{ state: getAccordionStatus(STATIC_SITE_MAP.SOLUTIONS.title) }}>
            <LargeCategory categoryKey="solutions" title={STATIC_SITE_MAP.SOLUTIONS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.SOLUTIONS)}>
              <AccordionToggle onToggle={(state) => setAccordionStatus(STATIC_SITE_MAP.SOLUTIONS.title, state)} />
              <SmallCategory>
                <SmallCategoryItem title={STATIC_SITE_MAP.SOLUTIONS_DX.title} url={getURLFromSitemapData(STATIC_SITE_MAP.SOLUTIONS_DX)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.SOLUTIONS_DEVELOPMENT.title} url={getURLFromSitemapData(STATIC_SITE_MAP.SOLUTIONS_DEVELOPMENT)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.SOLUTIONS_AI_RD.title} url={getURLFromSitemapData(STATIC_SITE_MAP.SOLUTIONS_AI_RD)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.SOLUTIONS_UX_UI.title} url={getURLFromSitemapData(STATIC_SITE_MAP.SOLUTIONS_UX_UI)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.SOLUTIONS_UNIVERSITY_DX.title} url={STATIC_SITE_MAP.SOLUTIONS_UNIVERSITY_DX.path} isOuterLink={true} />
                <SmallCategoryItem title={STATIC_SITE_MAP.SOLUTIONS_EDUCATION.title} url={getURLFromSitemapData(STATIC_SITE_MAP.SOLUTIONS_EDUCATION)} />
              </SmallCategory>
            </LargeCategory>
          </Context>
          <Context styles={styles} accordion={{ state: getAccordionStatus(STATIC_SITE_MAP.PRODUCTS.title) }}>
            <LargeCategory categoryKey="products" title={STATIC_SITE_MAP.PRODUCTS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.PRODUCTS)}>
              <AccordionToggle onToggle={(state) => setAccordionStatus(STATIC_SITE_MAP.PRODUCTS.title, state)} />
              <SmallCategory>
                <SmallCategoryItem title={'Monaca'} url={EXTERNAL_URL.MONACA} isOuterLink={true} />
                <SmallCategoryItem title={'Monaca Education'} url={EXTERNAL_URL.MONACA_EDUCATION} isOuterLink={true} />
                <SmallCategoryItem title={'Onsen UI'} url={EXTERNAL_URL.ONSEN_UI} isOuterLink={true} />
                <SmallCategoryItem title={'MyCampus'} url={EXTERNAL_URL.MY_CAMPUS} isOuterLink={true} />
                <SmallCategoryItem title={'ObjectiveFS'} url={EXTERNAL_URL.OBJECTIVE_FS} isOuterLink={true} />
                <SmallCategoryItem title={'JpGraph'} url={EXTERNAL_URL.JP_GRAPH} isOuterLink={true} />
              </SmallCategory>
            </LargeCategory>
          </Context>
          <Context styles={styles}>
            <LargeCategory categoryKey="works" title={STATIC_SITE_MAP.WORKS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.WORKS)} />
          </Context>
          <Context styles={styles} accordion={{ state: getAccordionStatus(STATIC_SITE_MAP.COMPANY.title) }}>
            <LargeCategory categoryKey="company" title={STATIC_SITE_MAP.COMPANY.title} url={getURLFromSitemapData(STATIC_SITE_MAP.COMPANY)}>
              <AccordionToggle onToggle={(state) => setAccordionStatus(STATIC_SITE_MAP.COMPANY.title, state)} />
              <SmallCategory>
                <SmallCategoryItem title={STATIC_SITE_MAP.COMPANY_MEMBERS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.COMPANY_MEMBERS)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.COMPANY_INFORMATION.title} url={getURLFromSitemapData(STATIC_SITE_MAP.COMPANY_INFORMATION)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.COMPANY_CLIENTS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.COMPANY_CLIENTS)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.COMPANY_NEWS_TOP.title} url={getURLFromSitemapData(STATIC_SITE_MAP.COMPANY_NEWS_TOP)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.PROFILE_PDF.title} url={getURLFromSitemapData(STATIC_SITE_MAP.PROFILE_PDF)} isOuterLink={true} icon="download" />
              </SmallCategory>
            </LargeCategory>
          </Context>
          <Context styles={styles} accordion={{ state: getAccordionStatus(STATIC_SITE_MAP.CAREERS.title) }}>
            <LargeCategory categoryKey="careers" title={STATIC_SITE_MAP.CAREERS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.CAREERS)}>
              <AccordionToggle onToggle={(state) => setAccordionStatus(STATIC_SITE_MAP.CAREERS.title, state)} />
              <SmallCategory>
                <SmallCategoryItem title={STATIC_SITE_MAP.CAREERS_INTERVIEWS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.CAREERS_INTERVIEWS)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.CAREERS_STORIES.title} url={getURLFromSitemapData(STATIC_SITE_MAP.CAREERS_STORIES)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.CAREERS_WORKSTYLE.title} url={getURLFromSitemapData(STATIC_SITE_MAP.CAREERS_WORKSTYLE)} />
                <SmallCategoryItem title={STATIC_SITE_MAP.CAREERS_JOBS.title} url={getURLFromSitemapData(STATIC_SITE_MAP.CAREERS_JOBS)} />
              </SmallCategory>
            </LargeCategory>
          </Context>
        </div>
        <div className={styles['sitemap-bottom']}>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.CONTACT)}>
            <button className={styles['contact-button']}>お問い合わせ</button>
          </a>
          <a className={styles['global-link']} href={EXTERNAL_URL.ASIAL_EN} target="_blank" rel="noreferrer">
            <img src={GlobalIconRef} />
            <span>Global</span>
          </a>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.SITE_POLICY)}>{STATIC_SITE_MAP.SITE_POLICY.title}</a>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.PRIVACY_POLICY)}>{STATIC_SITE_MAP.PRIVACY_POLICY.title}</a>
        </div>
      </div>
    </div>
  );
};

const LargeCategory = memo(({ categoryKey, title, url, children }: { categoryKey: string; title: string; url: string; children?: ReactNode }) => {
  const styles = useContext(StylesContext);
  return (
    <div className={cn(styles['large-category'], styles[`large-category__${categoryKey}`])}>
      <a href={url}>
        <div>{title}</div>
      </a>
      {children}
    </div>
  );
});
LargeCategory.displayName = 'LargeCategory';

const SmallCategory = memo(({ children }: { children?: ReactNode }) => {
  const styles = useContext(StylesContext);
  const { state } = useContext(AccordionContext) || {};
  return (
    <ul
      className={cn(styles['small-category'], {
        [styles['sp-opened']]: state === 'opened',
        [styles['sp-closed']]: state === 'closed'
      })}
    >
      {children}
    </ul>
  );
});
SmallCategory.displayName = 'SmallCategory';

const SmallCategoryItem = memo(({ title, url, isOuterLink = false, icon }: { title: string; url: string; isOuterLink?: boolean; icon?: 'download' }) => {
  const styles = useContext(StylesContext);
  const iconMeta = (() => {
    if (icon === 'download') {
      return { className: styles['dli'], xlinkHref: dli };
    }
    if (isOuterLink) {
      return { className: styles['oli'], xlinkHref: oli };
    }
    return null;
  })();

  return (
    <li className={styles['small-category-item']}>
      <img src={fld} className={styles['fld']} />
      <a href={url} target={isOuterLink ? '_blank' : '_self'} rel="noreferrer">
        {title}
      </a>
      {iconMeta && (
        <img className={iconMeta.className} src={iconMeta.xlinkHref} />
      )}
    </li>
  );
});
SmallCategoryItem.displayName = 'SmallCategoryItem';

const AccordionToggle = ({ onToggle }: { onToggle: (state: string) => void }) => {
  const styles = useContext(StylesContext);
  const { state } = useContext(AccordionContext) || {};

  return (
    <div
      className={cn('sp-only', styles['sp-accordion-toggle'])}
      onClick={() => {
        onToggle(state === 'opened' ? 'closed' : 'opened');
      }}
    >
      <img src={state !== 'opened' ? aop : acl} />
    </div>
  );
};
